import styled from 'styled-components';
import { Tabs } from 'antd';

export const LightTheme = {
    background:'#214972',
    textColor:'#fff',
    hoverColor:'#40a9ff',
    contentColor: '#fff'
};

export const DarkTheme = {
    background:'#0e2439',
    textColor:'#e6e6e6',
    hoverColor:'#1a73e8',
    contentColor: '#1f1f1f'
};

export const StyledTab = styled(Tabs)`
    .ant-tabs-nav{
    margin-bottom:16px;
    }
    .ant-tabs-nav-wrap{
    display:flex;
    justify-content:start;
    }
    .ant-tabs-tab{
    background: ${(props) => props.theme.background} !important;
    color: ${(props)=> props.theme.textColor} !important;
    margin:0px;
    padding:8px 16px;
    border-radius: 4px;
    transition: all 0.2s ease-in-out;

    &:hover{
    color: ${(props)=> props.theme.hoverColor} !important;
    }
    }
    .ant-tabs-tab-active{
    background:  ${(props)=> props.theme.contentColor} !important;
    color: black !important;
    font-weight:bold;
    }

`;